import { useQuery } from "@tanstack/react-query";
import { getMainstreamCareers } from "../services/dashboardService";
import { useSelector } from "react-redux";
import useLightcastToken from "./useLightcastToken";

const useMainstreamCareers = (currentJob) => {
  const { occupationId } = useSelector((state) => state.user);
  const { lightCastToken } = useLightcastToken();

  return useQuery({
    queryKey: ["mainstreamCareers", currentJob, occupationId, lightCastToken], 
    queryFn: () => getMainstreamCareers(occupationId, currentJob, lightCastToken),
    enabled: !!currentJob && !!occupationId && !!lightCastToken,
    staleTime: Infinity, 
    cacheTime: Infinity, 
    onError: (error) => {
      console.error("Error:", error.response?.data || error.message);
    },
  });
};

export default useMainstreamCareers;
